import styled from 'styled-components'
import { COLORS } from '../../../../styles/colors'

export const StyledYearPicker = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`

export const Header = styled.div`
	display: flex;
	align-items: center;

	margin-bottom: 16px;
`

export const YearList = styled.div`
	flex: 1;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;

	/* Кастомный скроллбар */
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: ${COLORS.secondary};
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: ${COLORS.icon};
	}
`

export const YearItem = styled.button`
	background: transparent;
	border: none;
	padding: 8px 16px;
	cursor: pointer;
	transition: all 0.2s ease;
	border-radius: 8px;
	width: 100%;
	max-width: 120px;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background: ${COLORS.backgroundHover};
	}
`
